import { MigrationSpec } from "../migration.models"

const aiPromptEngineVersions: MigrationSpec = {
  type: "MIGRATE_AI_PROMPT_ENGINE_VERSIONS",
  collection: "AiPrompts",
  risk: "INDEX",
  title: {
    en: "AI prompts → one per (name, role, engine layer)",
    tr: "AI promptları → (isim, rol, motor katmanı) başına bir kayıt"
  },
  description: {
    en:
      "Writes `engineVersion: null` (the BASE layer every engine version falls back to) onto " +
      "rows that predate it, then drops the pre-layer unique index on (name, role) so the " +
      "unique (name, role, engineVersion) index can take over.",
    tr:
      "Katman öncesi satırlara `engineVersion: null` (her motor sürümünün geri düştüğü BASE " +
      "katmanı) yazar, ardından (name, role) üzerindeki katman öncesi unique indeksi düşürerek " +
      "yerini unique (name, role, engineVersion) indeksine bırakır."
  },
  affectedFilter: { engineVersion: { $exists: false } },
  sampleFields: ["name", "role", "engineVersion", "usage"],
  indexes: {
    mustDrop: [{ keys: { name: 1, role: 1 }, unique: true }],
    mustExist: [{ keys: { name: 1, role: 1, engineVersion: 1 }, unique: true }]
  },
  preview: (doc) => ({ ...doc, engineVersion: null }),
  notes: [
    {
      en:
        "Until the old index is gone, forking a prompt into a newer engine's layer fails as a " +
        "duplicate (name, role) — the fork button cannot create a single row, and the error " +
        "names an index rather than what to do about it.",
      tr:
        "Eski indeks düşmeden bir prompt yeni motor katmanına fork edilemez; (name, role) " +
        "duplicate hatası alınır — fork düğmesi tek satır bile oluşturamaz ve hata, ne " +
        "yapılması gerektiğini değil yalnızca indeksi söyler."
    },
    {
      en:
        "Row content is untouched: every existing prompt becomes a BASE row, which is what " +
        "every engine version already reads. Nothing an engine answers with changes.",
      tr:
        "Satır içerikleri değişmez: mevcut her prompt BASE satırı olur, ki her motor sürümü " +
        "zaten onu okuyor. Motorun verdiği cevaplarda hiçbir değişiklik olmaz."
    }
  ]
}

export default aiPromptEngineVersions
